import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/redux';
import { authSlice } from '../../store/reducers/AuthSlice';
import { PasswordRecoveryAssistance } from '../../components/loginParts/PasswordRecoveryAssistance';

const PasswordRecoveryAssistancePage = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { setFormError } = authSlice.actions;

  const handleLink = useCallback(() => {
    dispatch(setFormError(null));
    history.push(`/`);
  }, [history]);

  return (
    <div className="login-page page">
      <div className="login-page__container container">
        <PasswordRecoveryAssistance handleLink={handleLink} />
      </div>
    </div>
  );
};

export default PasswordRecoveryAssistancePage;
